import {
	Botiquin,
	ConsultaMedicamentosState,
	ConsultaMedicamentosViews,
	Receta,
	ReservaConfirmationData,
	ReservaDTO,
} from 'utils/interfaces';
import { ConsultaMedicamentosInitialState } from '.';

export type Actions =
	| { type: 'reset' }
	| { type: 'nextPage' }
	| { type: 'resetPage' }
	| { type: 'setShowMiReceta' }
	| { type: 'setNotAvailable' }
	| { type: 'setShowInfoReceta'; payload: boolean }
	| { type: 'setInfoReceta'; payload: Receta }
	| { type: 'setFormLoading'; payload: boolean }
	| { type: 'setStatusMessage'; payload?: string }
	| { type: 'setBotiquines'; payload: Botiquin[] }
	| { type: 'filterByDepartamento'; payload: string }
	| { type: 'setView'; payload: ConsultaMedicamentosViews }
	| { type: 'setBotiquinForReservation'; payload?: Botiquin }
	| { type: 'setReservaExistente'; payload?: ReservaDTO }
	| { type: 'setModalReservaExistente'; payload: boolean }
	| { type: 'venceAhora' }
	| { type: 'setReservaConfirmationData'; payload?: ReservaConfirmationData };

export function reducer(
	state: ConsultaMedicamentosState,
	action: Actions
): ConsultaMedicamentosState {
	switch (action.type) {
		case 'setView': {
			return {
				...state,
				view: action.payload,
			};
		}
		case 'nextPage': {
			if (state.page >= state.totalPages) {
				return state;
			}

			const newPage = state.page + 1;
			const botiquinesInPage = [...state.botiquines].slice(
				0,
				newPage * state.perPage
			);

			return {
				...state,
				page: newPage,
				botiquinesInPage,
			};
		}
		case 'resetPage': {
			const botiquinesInPage = [...state.botiquines].slice(0, state.perPage);
			return {
				...state,
				page: 1,
				botiquinesInPage,
			};
		}
		case 'setFormLoading': {
			return {
				...state,
				isFormLoading: action.payload,
			};
		}
		case 'setNotAvailable': {
			return {
				...state,
				notAvailable: !state.notAvailable,
			};
		}
		case 'filterByDepartamento': {
			const searchText = action.payload.toUpperCase().trim();
			let botiquinesInPage;

			if (searchText.length === 0) {
				botiquinesInPage = [...state.botiquines].slice(0, state.perPage);
			} else {
				botiquinesInPage = state.botiquines.filter(
					({ departamento, botiquin, municipio }) => {
						return (
							searchText === departamento.toUpperCase() ||
							searchText === botiquin.toUpperCase() ||
							searchText === municipio.toUpperCase()
						);
					}
				);
			}
			return {
				...state,
				botiquinesInPage,
			};
		}
		case 'setBotiquines': {
			const botiquines = action.payload.sort((a, b) => {
				if (a.departamento > b.departamento) {
					return 1;
				}
				if (a.departamento < b.departamento) {
					return -1;
				}
				return 0;
			});
			const totalPages = Math.ceil(botiquines.length / state.perPage);
			const botiquinesInPage = [...botiquines].slice(0, state.perPage);

			return {
				...state,
				botiquines,
				totalPages,
				view: 'response',
				botiquinesInPage,
			};
		}
		case 'reset': {
			return ConsultaMedicamentosInitialState;
		}
		case 'setStatusMessage': {
			return {
				...state,
				statusMessage: action.payload,
			};
		}
		case 'setInfoReceta': {
			return {
				...state,
				infoReceta: action.payload,
			};
		}
		case 'setShowMiReceta': {
			return {
				...state,
				showMiReceta: !state.showMiReceta,
			};
		}
		case 'setShowInfoReceta': {
			return {
				...state,
				showInfoReceta: action.payload,
			};
		}
		case 'setBotiquinForReservation': {
			return {
				...state,
				botiquin: action.payload,
			};
		}
		case 'setReservaConfirmationData': {
			return {
				...state,
				view: 'confirmation',
				reservaConfirmationData: action.payload,
			};
		}
		case 'setReservaExistente': {
			return {
				...state,
				reservaExistente: action.payload,
			};
		}
		case 'setModalReservaExistente': {
			return {
				...state,
				showModalReservaExistente: action.payload,
			};
		}
		case 'venceAhora': {
			return {
				...state,
				venceAhora: true,
			};
		}
		default:
			return state;
	}
}
